import { render, staticRenderFns } from "./InvoiceForm.vue?vue&type=template&id=63080225&scoped=true&"
import script from "./InvoiceForm.vue?vue&type=script&lang=js&"
export * from "./InvoiceForm.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceForm.vue?vue&type=style&index=0&id=63080225&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63080225",
  null
  
)

export default component.exports